export default [
    {
        path: "/trafficInfo",
        component: resolve => require(["@/views/service/trafficInfo"], resolve),
        meta: {
            title: "交通信息"
        }
    },
    {
        path: "/Volunteer",
        component: resolve => require(["@/views/service/Volunteer"], resolve),
        meta: {
            title: "日照市博物馆/美术馆志愿者报名"
        }
    }

]


// WEBPACK FOOTER //
// ./src/router/modules/service.js